<template>
  <el-container class="full-height bg-gray">
    <el-main class="page-content">
      <el-main class="container" style="margin-bottom: 30px">
        <div class="title">微信扫码获取新订单通知</div>
        <div class="qrcode-box" ref="qrcode">
          <div id="qrCode">
            <canvas id="canvas"></canvas>
          </div>
          <div class="saveImg" @click="saveToImg">保存</div>
        </div>
      </el-main>
      <el-main class="container">
        <div class="title">绑定用户列表</div>
        <div class="table">
          <Table
            border
            align="center"
            :column="tableInfo.column"
            :data="tableInfo.data"
            :header-row-style="{height: '100px'}"
            :header-cell-style="{background:'#eef1f6',color:'#606266'}"
            :row-style="{height: '100px'}"
            pagination
            background
            :paginationTop="'30px'"
            :paginationAlign="'center'"
            layout="prev, pager, next, sizes, jumper"
            :page-sizes="[5, 10, 20, 30]"
            :pager-count="5"
            :current-page.sync="body.pageIndex"
            :total="tableInfo.total"
            :page-size="body.pageSize"
            @size-change="handleSizeChange"
            @p-current-change="handleCurrentChange"
          >
          </Table>
        </div>
      </el-main>
    </el-main>
    <el-dialog
      :visible.sync="dialogVisible"
      :show-close="false"
      width="25%">
      <div class="dialog-title">编辑</div>
      <div class="form-box">
        <div class="item">
          <span class="industry-title">请选择关联产业</span>
          <el-select v-model="selectIndustry" multiple @change="handleIndustry">
            <el-option
              v-for="item in industryList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </div>
        <div class="item">
          <div class="notice-title">请选择通知类型</div>
          <el-checkbox-group v-model="checkList">
            <el-checkbox label="会议室预定通知"></el-checkbox>
            <el-checkbox label="电子放行申请通知"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="btn-box">
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" @click="handleSubmit">保存</el-button>
        </div>
      </div>
    </el-dialog>
  </el-container>
</template>

<script>
import { getIndustrySelectList } from '@/api/industry'
import {
  getNoticeList,
  updateNotice,
  deleteNotice,
} from '@/api/notice'
import QRCode from 'qrcode'
import html2canvas from 'html2canvas'
export default {
  data() {
    return {
      dialogVisible: false,
      banners: [],
      body: {
        pageSize: 10,
        pageIndex: 1,
        word: '',
        industryUuid: ''
      },
      tableInfo: {
        total: 0,
        column: [
          {
            prop: 'name',
            label: '绑定用户昵称'
          },
          {
            label: '关联产业',
            render:(h, { row }) =>{
              let str = [],
                  text = ''
              row.industryNameList.forEach(item=>{
                str.push(item)
              })
              text = str.join('、')
              return <div>{text}</div>
            }
          },
          {
            label: '通知类型',
            render:(h, { row })=>{
              let str = []
              let text = ''
              row.isMeetingNotice === 1 ? str.push('会议室预定通知') : ''
              row.isReleaseNotice ? str.push('电子放行申请通知'): ''
              text = str.join('、')
              return <div>{ text }</div>
            }
          },
          {
            label: '操作',
            render: (h, { row }) => {
              return (
                <div>
                  <el-link v-show={this.hasAuthority('editNotice')} underline={false} type='primary' onClick={() => { this.handleEdit(row) }}>编辑</el-link>&nbsp;&nbsp;
                  <el-link v-show={this.hasAuthority('deleteNotice')} underline={false} type='primary' onClick={() => { this.handleDelete(row.uuid) }}>删除</el-link>&nbsp;&nbsp;
                </div>
              )
            }
          }
        ],
        data: []
      },
      currentPage: 1,
      pageSize: 5,
      checkList: [],
      //产业相关
      industryList: [],
      selectIndustry: [],
      //更新参数
      updateBody: {
        industryUuidList: [],
        isMeetingNotice: 0,
        isReleaseNotice: 0,
        uuid: ''
      }
    }
  },
  async created(){
    await this.network().getNoticeList()
    await this.network().getIndustrySelectList()
  },
  mounted(){
    this.initQRCode()
  },
  methods: {
    initQRCode(){
      var canvas = document.getElementById('canvas')
      QRCode.toCanvas(canvas, 'https://ahoke-mini-api.gymooit.cn/v1/cms/notice/WxTemplateLogin', function (error) {
        if (error) console.error(error)
        console.log('QRCode success!');
      })
    },
    network(){
      return{
        getNoticeList: async()=>{
          let { data } = await getNoticeList(this.body)
          this.tableInfo.data = data.list
          this.tableInfo.total = parseInt(data.total)
        },
        getIndustrySelectList: async() => {
          const { data } = await getIndustrySelectList()
          data.forEach(item => {
            this.industryList.push({
              value: item.uuid,
              label: item.name
            })
          })
        },
        updateNotice: async()=>{
          await updateNotice(this.updateBody)
          this.$message.success('更新成功')
          this.network().getNoticeList()
          this.dialogVisible = false
        },
        deleteNotice: async(uuid)=>{
          await deleteNotice(uuid)
          this.$message.success('删除成功')
          this.body.pageIndex = 1;
          this.network().getNoticeList()
          this.dialogVisible = false
        },
      }
    },
    handleSizeChange(size) {
      this.body.pageSize = size
      this.network().getNoticeList()
    },
    handleCurrentChange(current) {
      this.body.pageIndex = current
      this.network().getNoticeList()
    },
    handleEdit(row) {
      this.checkList = []
      this.selectIndustry = []
      this.updateBody.isMeetingNotice = row.isMeetingNotice
      this.updateBody.isReleaseNotice = row.isReleaseNotice
      this.updateBody.uuid = row.uuid

      if(row.industryUuidList.length > 0){
        this.selectIndustry = row.industryUuidList
      }

      if(row.isMeetingNotice === 1){
        this.checkList.push('会议室预定通知')
      }
      if(row.isReleaseNotice === 1){
        this.checkList.push('电子放行申请通知')
      }

      this.dialogVisible = true
    },
    handleIndustry(uuidList) {
      this.updateBody.industryUuidList = uuidList
    },
    handleClose(){
      this.dialogVisible = false
    },
    handleSubmit(){
      this.updateBody
      if(this.checkList.length > 0){
        this.checkList.indexOf('会议室预定通知') > -1 ? this.updateBody.isMeetingNotice = 1 : this.updateBody.isMeetingNotice = 0
        this.checkList.indexOf('电子放行申请通知') > -1 ? this.updateBody.isReleaseNotice = 1 : this.updateBody.isReleaseNotice = 0
      }
      this.network().updateNotice()
    },
    handleDelete(uuid){
      this.$confirm('是否删除该通知？', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.network().deleteNotice(uuid)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    saveToImg(){
      html2canvas(this.$refs.qrcode).then(res=> {
        const link = document.createElement('a')
        link.href = canvas.toDataURL()
        link.setAttribute('download','微信扫码获取新订单通知.png')
        link.style.display = 'none'
        document.body.appendChild(link)
        link.click()
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.title{
  font-weight: bold;
  font-size: 20px;
}
.table{
  margin-top: 30px;
}
/deep/.el-dialog{
  /deep/.el-dialog__header {
    padding: 0;
  }
  .dialog-title{
    font-size: 20px;
    font-weight: bold;
  }
  .form-box{
    .item{
      margin: 30px 0;
    }
    .industry-title{
      margin-right: 15px;
    }
    .notice-title{
      margin-bottom: 15px;
    }
    .btn-box{
      display: flex;
      justify-content: center;
      margin-top: 120px;
    }
  }
}
.qrcode-box{
  width: 150px;
  text-align: center;
  .saveImg{
    color: #169bd5;
  }
}
</style>
